<template>
    <div class="item">
        <div v-if="showHeader" class="brand_detail">
            <BtnPop :left="isPhone ? -190 : 0">
                <div slot="target" class="gi" style="height: 24px; width: 24px">
                    <GI name="brand_more" ws="24" hs="24" class="pointer icon_"></GI>
                </div>

                <div slot="main" :class="['type_main', globalThemeColor]">
                    <div v-for="(item, index) in tagList" :key="index" class="type_content">
                        <div @click="goRoute(item)" class="type_line">
                            <GI ws="20" hs="20" :name="item.icon"></GI>
                            <span class="title">{{ item.val }}</span>
                        </div>
                    </div>
                </div>
            </BtnPop>
        </div>

        <div class="image_out cursor" :style="{ height: `${hs}px`, width: `${ws}px` }">
            <div v-if="detail.isPrivate == 1" class="item_privacy">
                <GI name="brand_privacy_white" ws="20" hs="20"></GI>
            </div>
            <div class="item_image" :style="{ 
                backgroundImage: `url(${detail.banner})` 
            }" @click="isParticipant ? 
            jump_participant_compaign_preview({ id: detail.id }) : 
            jump_brand_compaign_preview({ status: status, id: detail.id, operateStop: detail.operateStop })"></div>
        </div>

        <div class="item_info">
            <div class="item_title">
                {{ detail.name }}
            </div>
            <div @click="isParticipant ? jump_participant_campaign_participants_profile({userId:detail.brandUserId}) : () => {}" class="item_belong">
                <div
                    class="belong_image"
                    :style="{
                        backgroundImage: `url(${brandUserVo.imageUrl})`,
                    }"
                ></div>
                <div class="belong_name">{{ brandUserVo.nickName }}</div>
            </div>
            <div class="item_desc">
                {{ detail.description }}
            </div>
            <CompaignVI v-show="showVI" :status="status" :isParticipant="isParticipant" :coll="detail.voteNum" :zan="detail.joinNum" :view="remainTime(detail.endTime).days" :arts="detail.workNum"></CompaignVI>

            <BTN @handle="$emit('openModel')" class="cardItem" v-if="showBotomBtn">{{ langJson('Submit Artwork') }}</BTN>

            <BTN @handle="$emit('unjoinHand')" fontSize="16" class="cardItem Unjoin" v-if="showBotomBtnUnjoin" v-show="isParticipant">{{ langJson('Unjoin') }}</BTN>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        ws: {
            type: [String, Number],
            default: '100%',
        },
        // 图片高度
        hs: {
            type: [String, Number],
            default: 'auto',
        },
        tagList: {
            type: Array,
            default: [],
        },
        showVI: {
            type: Boolean,
            default: true,
        },
        showBotomBtn: {
            type: Boolean,
            default: false,
        },
        showBotomBtnUnjoin: {
            type: Boolean,
            default: false,
        },
        // 是 brand 还是 Participant
        isParticipant: {
            type: Boolean,
            default: false,
        },
        showHeader: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: '',
        },
        detail: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        // 商户信息
        brandUserVo() {
            try {
                return this.detail.brandUserVo ? this.detail.brandUserVo : {}
            } catch (error) {
                return {}
            }
        },
    },
    methods: {
        unjoinHand() {
            // console.log('取消活动中所有的艺术品')
        },
        goRoute(item) {
            switch (item.number) {
                case 1:
                    this.jump_brand_compaign_preview({ status: this.status, id: this.detail.id })
                    break
                case 2:
                    this.jump_brand_compaign_overview({ status: item.status, from: 'edit', id: this.detail.id })
                    break
                case 3:
                    this.jump_brand_compaign_submissions({ status: item.status, idActive: this.detail.id })
                    break
                case 4:
                    this.delCompaign()
                    break

                default:
                    break
            }
        },
        async delCompaign() {
            this.$emit('delCompaign')
        },
    },
}
</script>
<style lang="scss" scoped>
.cardItem {
    height: 48px;
    border: 2px solid var(--primary_color);
    border-radius: 32px;
    padding: 12px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-family: 'Cabinet Grotesk';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
    color: var(--primary_color) !important;
    cursor: pointer;
    margin-top: 16px;
    user-select: none;
    &.Unjoin {
        border: 2px solid var(--danger_color);
        color: var(--danger_color) !important;
    }
}

.item {
    display: flex;
    flex-direction: column;

    .item_info {
        margin-top: 16px;

        .item_belong {
            .belong_name {
                font-family: 'Lato';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                color: var(--font_deep_color);
                margin-left: 8px;
            }
            .belong_image {
                height: 28px;
                width: 28px;
                border-radius: 50%;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
                overflow: hidden;
            }
            margin-top: 8px;
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        .item_desc {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: var(--font_deep_color);
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin-top: 4px;
            min-height: 40px;
            word-break: break-all !important;
        }
        .item_title {
            font-family: 'Inter';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 36px;
            color: var(--font_deep_color);

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 36px;
        }

        flex: 1;
    }

    .brand_detail {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;
    }

    .image_out {
        border-radius: 12px;
        overflow: hidden;
        background-color: rgba($color: #ccc, $alpha: 0.2);
        position: relative;
        .item_privacy {
            position: absolute;
            top:15px;
            left:15px;
            width: 40px;
            height: 40px;
            background-color: var(--danger_color);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 200;
        }

        .item_image {
            width: 100%;
            height: 100%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            transition: all 2s;
        }

        .item_image:hover {
            transform: scale(2);
        }
    }
}

.type_main {
    padding: 24px;
    background: var(--color_white);
    border: 1px solid var(--border_color);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    box-shadow: 4px 8px 24px rgba(187, 196, 221, 0.08);
    border-radius: 24px;
    cursor: pointer;

    .type_content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:last-child {
            color: var(--danger_color);
        }

        &:not(:last-child) {
            color: var(--font_deep_color);
        }

        .type_line {
            display: flex;
            align-items: center;
            gap: 8px;

            .title {
                white-space: nowrap;
                font-size: 14px;
                font-family: 'Lato';
            }
        }
    }
}

.theme_dark {
    box-sizing: border-box;
    gap: 24px;
    background: var(--nft_dialog_bg);
    border: 1px solid var(--nft_btnPop_border);
    border-radius: 8px;
}
@media screen and (max-width: 1081px) {
    .item {
        .item_info {
            .item_belong {
                .belong_name {
                    font-family: 'Lato';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 24px;
                    color: var(--font_deep_color);
                    margin-left: 8px;
                }
                .belong_image {
                    height: 28px;
                    width: 28px;
                    border-radius: 50%;
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    overflow: hidden;
                }
                margin-top: 8px;
                display: flex;
                align-items: center;
            }
        }
    }
    .brand_detail {
        margin-bottom: 12px !important;
    }

    .image_out {
        border-radius: 20px !important;
    }

    .item_info {
        margin-top: 12px !important;
    }

    .item_title {
        font-size: 16px !important;
        line-height: 24px !important;
        height: 24px !important;
    }

    .item_desc {
        height: 48px;
        margin-top: 4px;
        font-family: 'Lato';
        font-style: normal;
        font-weight: 400;
        font-size: 12px !important;
        line-height: 16px !important;
        display: flex;
        align-items: center;
        word-break: break-all !important;
    }
}
</style>
